import React from "react";
import APIS from "../../constant/EndPoint";
import ComboboxInput from "../Reusable/ComboboxInput";
import TextField from "../Reusable/TextField";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const StateForm = ({
  errors,
  register,
  setValue,
  getValues,
  clearErrors,
}: any) => {
  return (
    <div className={tw`grid sm:grid-cols-1 md:grid-cols-2 gap-x-4 mx-4`}>
      <ComboboxInput
        url={APIS.LOCATION_LIST}
        props={{ level: 0, is_active: true }}
        queryKey={"country"}
        register={register("parent")}
        errors={errors?.parent}
        name={"parent"}
        label={"Country"}
        setValue={setValue}
        placeholder={"Search Country"}
        getValues={getValues}
        clearErrors={clearErrors}
      />
      <TextField
        label={"Name"}
        register={register("name")}
        errors={errors?.name}
      />
    </div>
  );
};

export default StateForm;
